import * as React from 'react';
import { IEpiProps } from '../../state-helpers/epi-props';


export interface INoResultsProps {
    epiProps: IEpiProps;
}

export class NoResults extends React.Component<INoResultsProps, any> {
    render() {
        return (
            <div className="no-results" dangerouslySetInnerHTML={{ __html: this.props.epiProps.noResultsErrorText}} />
        );
    }
}